import React from "react";
import {
	Box,
	Container,
	Flex,
	Heading,
	IconButton,
	Img,
	Text,
	Link,
} from "@chakra-ui/react";
import { FaLinkedin } from "react-icons/fa";

const FundInFocusMay: React.FC = () => (
	<>
		{/* members */}
		<Flex
			as="section"
			flexDirection="column"
			overflow="hidden"
			justify="center"
			height={{ xs: "450px", sm: "300px" }}
			minH={{ xs: "450px", sm: "300px" }}
			maxH="450px"
			pos="relative"
		>
			<Img
				pos="absolute"
				objectFit="cover"
				src="/jpg/blogBanner.jpg"
				alt="members-hero"
				height="100%"
				width="100%"
			/>
			<Box
				bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
				pos="absolute"
				height="100%"
				width="100%"
				opacity="0.7"
			/>
			<Container
				maxW="container.xl"
				position="relative"
				zIndex="1"
				flexDir="column"
				px={{ xs: "20px", sm: "28px", md: "45px", lg: "60px", xl: "inherit" }}
			>
				<Heading
					as="h1"
					mb="20px"
					variant="reportCardTitle"
					fontSize={{ xs: "26px", sm: "28px", md: "32px", lg: "38px" }}
					color="white"
					lineHeight={{ xs: "34px", md: "39px", lg: "42px" }}
				>
					FUND IN FOCUS: Iron Pillar&apos;s Winning Startup Formula Combines Art
					and Science in Venture Investing
				</Heading>
			</Container>
		</Flex>
		<Container
			as="section"
			maxW="container.xl"
			pb="80px"
			pt="40px"
			minH="420px"
			display={{ xs: "flex", md: "inherit" }}
			flexDirection="column"
		>
			<Box as="main" w="100%" pb="40px">
				<Text variant="blogAnswer">
					Welcome to our ‘Fund in Focus’ series where we profile our member
					funds, underscore their investment philosophy, and highlight some of
					their interesting work. Today we speak to{" "}
					<Link
						href="https://www.linkedin.com/in/mjolly/"
						target="_blank"
						style={{
							textDecoration: "underline",
						}}
						rel="noreferrer"
					>
						Mohanjit Jolly
					</Link>
					, Partner,{" "}
					<Link
						href="https://ironpillarfund.com/"
						target="_blank"
						style={{
							textDecoration: "underline",
						}}
						rel="noreferrer"
					>
						Iron Pillar
					</Link>
					. In this feature he shares the venture fund’s vision to back high
					value start-ups who are “building from India for the world”, the close
					of its $129Mn cloud fund, top investment trends and the fund’s bullish
					approach towards investing in enterprise centric sectors in 2023.
				</Text>
			</Box>

			<Img
				src="https://static.levocdn.com/WGLBUT82/7066796965192688227.png"
				alt="Mohanjit Jolly"
				width="300px"
				float={{ xs: "right", md: "left" }}
				alignSelf={{ xs: "center", md: "flex-start" }}
				mx={{ xs: "0px", md: "0px" }}
				mr={{ xs: "0px", md: "40px", lg: "60px", xl: "70px" }}
				mb="20px"
				objectFit="contain"
			/>
			<Box>
				<Link
					display="flex"
					alignItems="center"
					href="https://www.linkedin.com/in/mjolly/"
					target="_blank"
				>
					<IconButton
						aria-label="linkedin"
						icon={<FaLinkedin size="28px" color="rgba(100, 100, 140, 0.6)" />}
						variant="unstyled"
						cursor="pointer"
					/>
					<Heading
						fontWeight="800"
						variant="blogQuestion"
						fontSize="20px"
						opacity="0.8"
					>
						Mohanjit Jolly
					</Heading>
				</Link>
				<Box
					ml={{ xs: "auto", md: "345px", lg: "370px" }}
					mr={{ xs: "auto", md: "0px" }}
					width={{ xs: "160px", md: "80px" }}
					h="2px"
					bgColor="primary.500"
					borderRadius="5px"
					mt={{ xs: "16px", md: "10px" }}
					mb="15px"
				/>
				<Box mt="16px" mb="20px">
					<Heading variant="blogQuestion" mb="20px">
						1. True blue mid-stage growth venture investors are limited in India
						and Iron Pillar is one of the prominent ones operating in this
						space. How would you describe the fund’s investment strategy for
						‘new India’.
					</Heading>
					<Text variant="blogAnswer">
						The team at Iron Pillar believes, as do many others, that the
						roaring 2020’s is India’s decade in terms of innovation and
						entrepreneurship. Iron Pillar has been a fundamental believer in
						backing startups “building from India for the world” ever since our
						founding seven years ago. Most of our investments address global
						markets, in addition to India and we believe that Indian
						entrepreneurs will continue to build large global technology
						companies from India. That thesis is paying dividends given the
						massive growth that virtually every one of our investments is
						witnessing.
						<br />
						<br />
						In terms of capital invested, we invest $10-15M in the initial round
						of our entry in a company and then double down on our winners for
						~$50M. We prefer to own 10% to 30% of the businesses we invest in.
					</Text>
				</Box>
				{/* Question 2 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pb="20px" pt="12px">
						2. How do you spot your &apos;winning&apos; start-ups?
					</Heading>

					<Text variant="blogAnswer" pt="8px">
						VC investing is a combination of art and science, qualitative and
						quantitative, eq and iq, the emotional and the rational, leveraging
						the heart/gut/intuition and the mind. Iron Pillar invests in
						companies that are post the early-stage product-market risk, and
						usually when the ARR is between $4M and $10M (for SaaS companies,
						for example). Therefore, there is market and financial data that can
						be analyzed, looking for trends around typical financial metrics
						such as Gross Margins, YoY growth, Customer Acquisition Cost etc.
						The Iron Pillar team has created its own rubric to analyze
						investment opportunities based on the business data. But often, the
						decision making comes down to our fundamental belief in the
						entrepreneur(s) to execute and scale the business. We have a “force
						of nature” question whereby we look for that combination of
						self-awareness, resilience, and grit on the part of the
						entrepreneurs to overcome headwinds. Additionally, entrepreneurs
						need to have the ability to sell, not just the product but also the
						vision of the company. That attracts employees, customers, and
						downstream investors. At Iron Pillar, we are looking for companies
						that aim to be unicorns, in large markets, with global ambitions.
						The calculus for us is a combination of the team (first and
						foremost), technology (potential for #1 or #2 in their industry),
						traction (product-market fit, retention, positive CAC and CAC
						payback trends etc.) and sizable market to create a billion-dollar+
						outcome.
					</Text>
				</Box>

				{/* Question 3 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="28px">
						3. How are you deploying new capital so far in 2022 and plan to
						utilize it next year?
					</Heading>
					<Text variant="blogAnswer" mt="16px" mb="8px">
						The team has been busy making new investments and working deeply
						with existing companies over the last few quarters. Till date, Iron
						Pillar Fund II has invested in six companies mostly focused on our
						thesis of building from India for the world. We have formally
						announced five of those investments (CoreStack, Ushur, Jiffy.ai,
						Skill-Lync and Curefoods). All these investments leverage the Cloud
						as the enabling infrastructure with most of them falling in the SaaS
						category. We will be active in calendar 2023 continuing to make new
						investments. Our strategy is one of a concentrated portfolio and
						going deep with our portfolio companies in terms of hands-on help
						with business development, recruiting, GTM and downstream capital.
						That approach has helped build a strong reputation for the brand and
						resulted in significant referral network being created in the market
						through our existing portfolio entrepreneurs, co-investors, LPs and
						the broader startup ecosystem.
					</Text>
				</Box>

				{/* Question 4 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="16px">
						4. Iron Pillar&apos;s close of its $129 million cloud fund, do
						elaborate on the cloud opportunity and impact on India&apos;s
						digital economy in the coming years.
					</Heading>
					<Text variant="blogAnswer" py="16px">
						As we think about companies “building from India for the world”,
						cloud is a foundational technology that enterprise and consumer
						centric companies have leveraged, are leveraging and will leverage
						going forward, either exclusively or in conjunction with on-premise
						solutions.
						<br />
						<br />
						Our Global Cloud Fund’s emphasis is primarily enterprise-centric
						SaaS companies. Several of our star investments from this fund,
						including Ushur, Pando, Jiffy and CoreStack, are “cloud native”,
						meaning that their product is architected from the ground up to take
						advantage of the flexibility, scalability, maintainability and
						agility that the cloud provides. CoreStack itself is a Cloud
						Governance solution which enables enterprise to transition from
						on-Prem to a cloud-only or hybrid environment efficiently,
						effectively and securely.
						<br />
						<br />
						Global cloud spend in 2023 is projected to grow to almost $600B, up
						from $400B two years ago. Overall IT spend is forecasted to be $4.6T
						in 2023. So while the cloud spend is definitely becoming a bigger
						piece of the IT pie, that trend will likely continue for several
						years to come. While public cloud vendors like AWS, GCP and Azure
						will clearly be large beneficiaries, many start-ups at the
						infrastructure and application layers will benefit as well. India
						will definitely provide more than its fair share of start-ups that
						will be part of that cloud wave. Finally, disruptive technologies
						such as generative AI are built natively in the cloud and are acting
						as yet another catalyst for further cloud adoption.
					</Text>
				</Box>
				{/* Question 5 */}
				<Flex mt="8" mb="20px" gap="1rem">
					<Box my="16px">
						<Heading variant="blogQuestion" pt="16px">
							5. Elaborate on the impact created by some of your portfolio
							companies in consumer-tech space.
						</Heading>
						<Text variant="blogAnswer" py="16px">
							Iron Pillar’s portfolio include high performing consumer-tech
							companies such as FreshToHome, BlueStone and CureFoods as well as
							consumer + B2B companies like Servify and Skill-Lync. Skill-Lync,
							our star engineering upskilling company, is building a stellar
							platform for training for future-ready jobs in categories such as
							Automotive (think EV’s and Battery Management), Telecommunications
							(think 5G transformation), Defense and Aerospace and more. The
							impact from a platform like
							<Text as="span" fontWeight="700">
								{" "}
								Skill-Lync
							</Text>{" "}
							is obvious and significant. Whether its fresh college graduates
							looking for job-ready, project-centric skills, mid-career
							individuals fighting obsolescence in a particular market by
							re-inventing themselves, Skill-Lync is life changing. The company
							has had a meaningful impact on thousands of students thus far not
							only by training them in new technical skills, but helping place
							them with top notch local companies as well as MNC.
							<br />
							<br />
							<Text as="span" fontWeight="700">
								FreshToHome
							</Text>{" "}
							is another phenomenal company in the consumer-tech space focused
							on providing fresh fish and meat from the source directly to the
							consumers at a competitive price, without any preservatives within
							24-36 hours. Technologically, the company has built incredible
							expertise in supply chain, demand generation, predictive
							analytics, personalization and much more. Shan, the co-founder and
							former head of{" "}
							<Text as="span" fontWeight="700">
								Zynga
							</Text>
							, India is a true “force of nature” with laser focused execution
							that has led{" "}
							<Text as="span" fontWeight="700">
								FTH
							</Text>{" "}
							to become a leader in their category. The company has grown from
							India to the UAE market, and now expanding into other parts of the
							Middle East. FTH’s impact is really two-fold – for the consumers,
							the company delivers the highest quality, fresh product through a
							combination of value and convenience; just as importantly, they
							help the fishermen improve their income and quality of life
							through fair and transparent pricing. The company also has, as
							part of the Kerala heritage, a mission of giving back to the local
							fishermen communities, something that is a rarity in the overall
							entrepreneurial ecosystem.
							<br />
							<br />
							<Text as="span" fontWeight="700">
								Curefoods
							</Text>{" "}
							is one of Iron Pillar’s more recent investments. And again, the
							investment thesis was focused in large part of Ankit Nagori, the
							founder/ceo as well as the burgeoning market for healthy and tasty
							food in the Indian market. One of Ankit’s passions is “healthy
							lifestyle”. After a successful career at Flipkart, he and Mukesh
							Bansal co-founded Curefit which was eventually acquired by the
							Tata Group. Ankit decided that for a young healthy India, food was
							just as important, if not more so, than exercise. Being a
							technologist at heart, he leveraged the cloud kitchen concept to
							build Curefoods, steadily acquiring and building new brands under
							the Curefoods umbrella. As a result, Curefoods is now the second
							largest house of food brands in India, impacting thousands and
							soon, tens of thousands of Indians with healthy, convenient, and
							affordable food options. Now that’s impact!
						</Text>
					</Box>
					<Img
						mt="20px"
						src="https://static.levocdn.com/WGLBUT82/7066801111768130949.jpg"
						alt="Infographic"
						w="43%"
						objectFit="contain"
						display={{ xs: "none", sm: "block" }}
					/>
				</Flex>
				{/* Question 6 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="16px">
						6. With record dry powder waiting to be invested, capital investment
						today is at a tipping point in India. What’s your outlook for
						funding revival in 2023?
					</Heading>
					<Text variant="blogAnswer" py="16px">
						2023 is going to be a very interesting year for the Indian tech
						startup ecosystem. Investors who have dry powder, like Iron Pillar,
						will be in a good position to invest in interesting companies at
						relatively reasonable valuations compared to the last few years. At
						the same time, investors with sizable portfolios and companies
						facing cash crunch in the coming months and quarters may be forced
						to deploy capital in their existing companies through convertible
						notes/SAFEs or through insider-led rounds. Investors who have been
						disciplined about valuations and not getting caught up in the FOMO
						trends will do well in 2023. From a startups’ standpoint, those who
						are solving real problems and finding true product-market fit, will
						be able to raise capital, although they will have to have more
						realistic valuation expectations and will have to ensure that cash
						burn is controllable. Investors may still worry in 2023 to back high
						cash burning businesses without a clear path to profitability. We
						suspect that the overall investment and diligence process will be
						longer as investors will likely spend more time and dig deeper into
						the business before investing. We have started to see those trends
						earlier this year, and expect them to continue throughout 2023.
						Another trend to keep an eye on will be M&A and consolidation in
						certain sectors where scale will matter and therefore, multiple
						companies coming together will be the right recipe for long term
						success rather than the “go it alone” approach. We are starting to
						see that trend already.
					</Text>
				</Box>
				{/* Question 7 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="16px">
						7. Which sectors will be significant growth drivers for Indian
						digital economy?
					</Heading>
					<Text variant="blogAnswer" py="16px">
						There are several sectors to be excited about within the Indian
						digital economy. India’s young demographic and constant digitization
						across metros and tier 3/4/5 towns and villages create huge
						tailwinds for several sectors. Fin-tech and logistics were both
						pre-cursors and beneficiaries of the e-commerce and m-commerce
						growth; one of Iron Pillar’s core investment themes is future of
						work and education. With a young, aspirational, connected
						demographic, education and skilling are not “nice to have’s” but
						“must have’s” for India to prosper and not run into an issue of high
						unemployment. There is a massive need and opportunity around
						sustainability and climate-change centric technologies, not just in
						terms of mimicking successes in the US or Europe, but coming up with
						a very bespoke set of solutions for the Indian market,
						infrastructure and customer set. Climate change is driving several
						other trends that technologies and startups will need to address,
						around sustainable agriculture, housing, pollution, waste, water
						etc. With a young population, immersive entertainment, gaming,
						edutainment will be interesting themes. And while healthcare (remote
						and tele-medicine) have been talked about and needed in India, there
						are massive supply-demand gaps that need to be bridged, both in
						urban and especially in rural areas. The government has done a great
						job with the overall digitization push in India, and UPI has ushered
						an era of providing efficient and effective financial rails for
						content, community, and commerce. There will need to be Indianized
						versions of AR/VR technologies that will emerge. Gaming has huge
						upside in India and cloud infrastructure as well as ubiquitous
						mobile connectivity provides a strong foundation on which fantastic
						companies will be built, not just for India but for the world. We
						are starting to see initial successes in that sector as well.
						<br />
						<br />
						In terms of “India for the world” enterprise centric sectors, Iron
						Pillar is bullish on multiple themes including Cybersecurity (which
						will continue to be an issue as more and more connectivity enters
						both the consumer and enterprise lives); DevOps (as cloud becomes
						ubiquitous, new sets of tools and platforms will be needed to ease
						and optimize that transition); enterprise transformation broadly is
						a core theme that will continue to create massive companies from
						India leveraging foundational technologies around AI/ML, Natural
						Language Processing, No-code/Low-code, Edge Computing, and open
						source platforms such as ChatGPT (by OpenAI). Vertical SaaS offering
						around financial services, healthcare, manufacturing, retail etc.
						are also interesting sectors with Indian entrepreneurs building for
						the world. While there is only one pure play public Indian SaaS
						company on Nasdaq (FRSH), the next few years will see a
						proliferation of several other companies on global exchanges.
					</Text>
				</Box>
				{/* Question 8 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="16px">
						8. Tell us the top three aspects entrepreneurs and start-ups should
						keep in mind while approaching Iron Pillar for funding.
					</Heading>
					<Text variant="blogAnswer" py="16px">
						Stage, sector and scale: Iron Pillar invests in companies that are
						post product-market fit (between $4-$10M in ARR) and are typically
						raising either Series B or Series C capital; our focus primarily is
						investing in companies that are “building from India for the world”
						(development in India, and markets globally - including India); Our
						goal is to invest in visionary entrepreneurs looking to build
						massive companies addressing large global markets. Our goal is to
						help companies reach $100M+ in ARR or revenue, and have a line of
						sight towards becoming Unicorns.
					</Text>
				</Box>
			</Box>
			<Heading
				variant="blogQuestion"
				lineHeight="30px"
				pt="16px"
				fontStyle="italic"
				p="12px 12px 0px"
			>
				The content in this section is curated by Team IVCA. For any feedback,
				connect with&nbsp;
				<Link
					href="mailto:paromita.sinha@ivca.in"
					target="_blank"
					style={{ color: "blue", textDecoration: "underline" }}
				>
					paromita.sinha@ivca.in
				</Link>
			</Heading>
		</Container>
	</>
);

export default FundInFocusMay;
